<ng-container>
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ title }}</span>

        <button
            mat-icon-button
            type="button"
            [attr.aria-label]="'customers.ui.chiudi' | transloco"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    @if (isViewMode) {
        <mat-dialog-content class="content content-view">
            <div class="note-view-card">
                <span class="body-small">{{ data.note?.data | date:'dd/MM/yyyy HH:mm' }}</span>
                <span class="body-medium-emphasized">{{ data.note?.titolo }}</span>
                <span class="body-small">{{ data.note?.testo }}</span>
            </div>
        </mat-dialog-content>
    } @else {
        <mat-dialog-content class="content" [formGroup]="noteForm">
            <mat-form-field appearance="outline" class="titolo-field" subscriptSizing="dynamic">
                <mat-label>{{ 'customers.ui.titoloNota' | transloco }}</mat-label>
                <input matInput formControlName="titolo">
                @if (noteForm.controls.titolo.hasError('required')) {
                    <mat-error>{{ 'customers.ui.ilTitoloEObbligatorio' | transloco }}</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline" class="text-area-custom">
                <mat-label>{{ 'customers.ui.testoNota' | transloco }}</mat-label>
                <textarea matInput formControlName="testo" rows="4"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{ 'customers.ui.dataNota' | transloco }}</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="data" [placeholder]="'customers.ui.datePlaceholder' | transloco">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <div class="note-option-card">
                <div class="note-option-card-content">
                    <span class="body-medium-emphasized">{{ 'customers.ui.aggiungiAdOgniRichiestaAutorizzazioneOrdine' | transloco }}</span>
                    <span class="body-small">{{ 'customers.ui.laNotaSaraPropostaAutomaticamenteQuandoSiCreaUnaRichiestaAutorizzazioneOrdinePerQuestoCliente' | transloco }}</span>
                </div>

                <mat-slide-toggle formControlName="addOrdine" [attr.aria-label]="'customers.ui.aggiungiAdOgniRichiestaAutorizzazioneOrdine' | transloco"></mat-slide-toggle>
            </div>
        </mat-dialog-content>
    }

    <mat-dialog-actions class="buttons-container" [class.buttons-container-view]="isViewMode">
        @if (isViewMode) {
            @if (data.note?.canEditNote) {
                <button matButton="filled" type="button" (click)="onEdit()">{{ 'customers.ui.modifica' | transloco }}</button>
            }
            <button matButton type="button" (click)="onClose()">{{ 'customers.ui.chiudi' | transloco }}</button>
        } @else {
            <button matButton type="button" (click)="onReset()">{{ 'customers.ui.cancella' | transloco }}</button>
            <button matButton="filled" type="button" (click)="onApply()">{{ 'customers.ui.salva' | transloco }}</button>
        }
    </mat-dialog-actions>
</ng-container>
